import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-page',
  standalone: true,
  imports: [],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.css'
})
export class ErrorPageComponent implements OnInit {
  errorMessage: string = 'The page you are looking for does not exist.';
  errorCode: string = '404 - PAGE NOT FOUND';

  constructor(private router: Router) { }
 
  ngOnInit(): void {
    if (this.router.url === '/Error/404.') {
      this.router.navigate(['/Error/404']);
    }
    const rCode = this.router.url.split('/').pop() || '404';
    if (rCode === '403') {
      this.errorCode = '403 - ACCESS DENIED';
      this.errorMessage = 'You do not have permission to access this page.';
    } else if (rCode === '404') {
      this.errorCode = '404 - PAGE NOT FOUND';
      this.errorMessage = 'The page you are looking for does not exist.';
    }

  }
  logOut() {
    localStorage.clear();
    sessionStorage.clear();
    if (environment.isLogoOutFromLive === '1') {
      window.location.href = 'https://login.teamleaseregtech.com/logout.aspx';
    } else {
      this.router.navigate(['/Login']);
    }

  }
}
